import React from "react";
import { useNavigate } from "react-router-dom";
import GCPReportsTemplate from "@/components/templates/GCPReportsTemplate";
import AWSReportsCards from "@/components/organisms/AWSReportsCards";

function GCPReports() {
  const navigate = useNavigate();

  const reportCards = [
    {
      title: "GCP",
      description: "View Datadog GCP Dashboard",
      action: () => navigate("/gcp/reports/datadog-gcp"),
      enabled: true,
      icon: "/Datadog_Icon.png",
    },
  ];

  return (
    <GCPReportsTemplate title="GCP Reports" showBackButton={false}>
      <AWSReportsCards reportCards={reportCards} />
    </GCPReportsTemplate>
  );
}

export default GCPReports;


